<ui-dropdown-list
  *ngIf="menuOptions"
  [data]="menuOptions"
  [dataSubMenu]="subMenuOptions"
  [menuModel]="menuOptionSelected"
  [subMenuModel]="subMenuOptionSelected"
  eventType="click"
  dropPosition="bottom-end"
  (select)="selectOption($event)"
  (open)="menuOpen($event)"
>
  <ng-template #dropdownButton>
    <div *ngIf="useLabel; else sortingIcon" class="sorting-wrapper">
      <ui2-button class="button-with-icon">
        <label class="label-sm-semibold-single">{{ menuOptionSelected.label | translate }}</label>
        <div class="icon2-x16-micro-chevron-m" [class.open]="open"></div>
      </ui2-button>
    </div>

    <ng-template #sortingIcon>
      <ui2-button class="button-icon">
        <span class="icon icon2-x16-{{ subMenuOptionSelected?.uri === 'desc' ? 'descending' : 'ascending' }}"> </span
      ></ui2-button>
    </ng-template>
  </ng-template>

  <ng-template #dropdownList let-item>
    {{ item.label | translate }}
  </ng-template>

  <ng-template #dropdownSubMenuList let-item>
    {{ item.label | translate }}
  </ng-template>
</ui-dropdown-list>
